// extracted by mini-css-extract-plugin
export default {"grid":"ContentColumns_grid__tolLe","content":"ContentColumns_content__37eNL"};